import { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "../styles/custom-time-picker.scss";

const CustomTimePicker = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hour, setHour] = useState(value ? value.getHours() % 12 || 12 : 12);
  const [minute, setMinute] = useState(value ? value.getMinutes() : 0);
  const [period, setPeriod] = useState(
    value && value.getHours() >= 12 ? "PM" : "AM"
  );

  useEffect(() => {
    let newDate = new Date(value);
    let adjustedHour = hour;
    if (period === "PM" && hour !== 12) adjustedHour += 12;
    if (period === "AM" && hour === 12) adjustedHour = 0;

    newDate.setHours(adjustedHour, minute, 0);
    onChange("time", newDate); // Send updated time to parent
  }, [hour, minute, period]);

  const incrementHour = () => setHour((prev) => (prev === 12 ? 1 : prev + 1));
  const decrementHour = () => setHour((prev) => (prev === 1 ? 12 : prev - 1));

  const incrementMinute = () =>
    setMinute((prev) => (prev === 59 ? 0 : prev + 1));
  const decrementMinute = () =>
    setMinute((prev) => (prev === 0 ? 59 : prev - 1));

  // Ensure hour and minute are displayed with two digits
  const formatNumber = (num) => String(num).padStart(2, "0");

  const togglePeriod = () => setPeriod((prev) => (prev === "AM" ? "PM" : "AM"));

  return (
    <div className="custom-time-picker">
      <label className={`time-label active ${isOpen ? "isOpen" : ""}`}>
        Time
      </label>
      <Dropdown
        className={`dropdown ${isOpen ? "active" : ""}`}
        show={isOpen}
        onToggle={(isOpen) => setIsOpen(isOpen)}
      >
        <Dropdown.Toggle variant="success" className="dropdown-toggle-comm">
          <span>
            {isOpen
              ? "Select"
              : hour + ":" + formatNumber(minute) + " " + period}
          </span>
          {isOpen ? (
            <i
              className={`fa fa-chevron-up ${isOpen ? "arrow-active" : ""}`}
            ></i>
          ) : (
            <i className="fa fa-chevron-down"></i>
          )}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <div className="dropdown-container-comm">
            <div className="d-flex justify-space-between">
              <div className="custom-time-column">
                <i className="fa fa-chevron-up" onClick={incrementHour}></i>
                <span>{formatNumber(hour)}</span>
                <i className="fa fa-chevron-down" onClick={decrementHour}></i>
              </div>
              <div className="custom-time-columm-colon">
                <i className="fa fa-colon"></i>
              </div>
              <div className="custom-time-column">
                <i className="fa fa-chevron-up" onClick={incrementMinute}></i>
                <span>
                  {" "}
                  <span>{formatNumber(minute)}</span>
                </span>
                <i className="fa fa-chevron-down" onClick={decrementMinute}></i>
              </div>
              <div className="custom-time-column">
                <i className="fa fa-chevron-up" onClick={togglePeriod}></i>
                <span>{period}</span>
                <i className="fa fa-chevron-down" onClick={togglePeriod}></i>
              </div>
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default CustomTimePicker;
